import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form } from 'react-bootstrap';
import { fetchSendCommand } from '../commonApi';
import { toast } from 'react-toastify';

const SendCommandDialog = ({ show, onHide, thingName }) => {
    const [payload, setPayload] = useState('');

    useEffect(() => {
        if (!show) {
            setPayload('');
        }
    }, [show]);

    const handleSendCommand = async () => {
        let parsedPayload;
        try {
            parsedPayload = JSON.parse(payload);
        } catch (error) {
            toast.error('Invalid JSON format.');
            return;
        }

        try {
            const response = await fetchSendCommand(thingName, parsedPayload);
            const successMsg = response.data.status || 'Command sent successfully!';
            toast.success(successMsg);
        } catch (error) {
            const errorMsg = error?.response?.data?.error.details?.errorMessage || 'Server Error';
            toast.error(errorMsg);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title style={{color:"#4340d2"}}>Send Command</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formDeviceName" className="mb-3">
                        <Form.Label>Device Name<span className="required-asterisk" style={{color: "red"}}>*</span></Form.Label>
                        <Form.Control type="text" value={thingName} disabled style={{ cursor: "not-allowed" }} />
                    </Form.Group>
                    <Form.Group controlId="formJsonPayload" className="mb-3">
                        <Form.Label>Payload (JSON)<span className="required-asterisk" style={{color: "red"}}>*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            value={payload}
                            onChange={(e) => setPayload(e.target.value)}
                            placeholder='Enter JSON payload'
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='sc-modal-footer'>
                <button type="button" className="btn light_primary_btn me-3" onClick={onHide}>
                    Cancel
                </button>
                <button className='btn primary_btn btn-loader' onClick={handleSendCommand}>
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
};

SendCommandDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    thingName: PropTypes.string.isRequired,
};

export default SendCommandDialog;
